export async function fetchImage (uri) {
	const res = await fetch(uri);

	if (!res.ok) {
		throw new Error(`fetchImage - HTTP error! status: ${res.status}, url: ${res.url}`);
	}

	const blob = await (res).blob();

	if (!blob.type.startsWith('image/')) {
		throw new Error(`fetchImage - expected blob type to be of type image/*, instead have: ${blob.type}, for url: ${res.url}`);
	}

	return bufferToImage(blob);
}
export function bufferToImage (buf) {
	return new Promise((resolve, reject) => {
		if (!(buf instanceof Blob)) reject(new Error('bufferToImage - expected buf to be of type: Blob'));
		const reader = new FileReader();
		reader.onload = () => {
			if (typeof reader.result !== 'string') reject(new Error('bufferToImage - expected reader.result to be a string, in onload'));
			const img = new Image();

			img.onload = () => resolve(img);
			img.onerror = reject;
			img.src = reader.result;
		};
		reader.onerror = reject;
		reader.readAsDataURL(buf);
	});
}
